var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcbOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7698 25.5492C44.7698 29.1048 41.8746 32 38.319 32H3.22058V6.45079C3.22058 2.89524 6.11582 0 9.67138 0H44.7698V25.5492V25.5492Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3427 18.9967H36.0093C36.0855 18.9967 36.2633 18.9713 36.3395 18.9713C36.8474 18.8697 37.2792 18.4126 37.2792 17.7776C37.2792 17.1681 36.8474 16.711 36.3395 16.584C36.2633 16.5586 36.1109 16.5586 36.0093 16.5586H33.3427V18.9967Z",
    fill: "url(#paint0_linear_14_1334)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7043 2.15869C33.1646 2.15869 31.082 4.21583 31.082 6.78091V11.5809H37.609C37.7614 11.5809 37.9392 11.5809 38.0662 11.6063C39.5392 11.6825 40.6312 12.4444 40.6312 13.765C40.6312 14.8063 39.8947 15.6952 38.5233 15.873V15.9238C40.0217 16.0254 41.1646 16.8635 41.1646 18.1587C41.1646 19.5555 39.8947 20.4698 38.2185 20.4698H31.0566V29.8666H37.8376C40.3773 29.8666 42.4598 27.8095 42.4598 25.2444V2.15869H35.7043V2.15869Z",
    fill: "url(#paint1_linear_14_1334)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.949 14.0697C36.949 13.4602 36.5173 13.0539 36.0093 12.9777C35.9585 12.9777 35.8315 12.9523 35.7554 12.9523H33.3427V15.1872H35.7554C35.8315 15.1872 35.9839 15.1872 36.0093 15.1618C36.5173 15.0856 36.949 14.6793 36.949 14.0697V14.0697Z",
    fill: "url(#paint2_linear_14_1334)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1541 2.15881C7.61441 2.15881 5.53187 4.21596 5.53187 6.78104V18.1842C6.8271 18.8191 8.17314 19.2255 9.51917 19.2255C11.1192 19.2255 11.9827 18.2604 11.9827 16.9398V11.5556H15.9446V16.9144C15.9446 18.9969 14.6493 20.6985 10.2557 20.6985C7.58901 20.6985 5.50647 20.1144 5.50647 20.1144V29.8414H12.2874C14.8271 29.8414 16.9096 27.7842 16.9096 25.2191V2.15881H10.1541V2.15881Z",
    fill: "url(#paint3_linear_14_1334)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9284 2.15881C20.3887 2.15881 18.3062 4.21596 18.3062 6.78104V12.8255C19.4744 11.835 21.5062 11.2001 24.7823 11.3525C26.5347 11.4287 28.4141 11.9112 28.4141 11.9112V13.8668C27.4744 13.3842 26.3569 12.9525 24.9093 12.8509C22.4204 12.6731 20.922 13.8921 20.922 16.0255C20.922 18.1842 22.4204 19.4033 24.9093 19.2001C26.3569 19.0985 27.4744 18.6414 28.4141 18.1842V20.1398C28.4141 20.1398 26.5601 20.6223 24.7823 20.6985C21.5062 20.8509 19.4744 20.216 18.3062 19.2255V29.8921H25.0871C27.6268 29.8921 29.7093 27.835 29.7093 25.2699V2.15881H22.9284V2.15881Z",
    fill: "url(#paint4_linear_14_1334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_1334",
    x1: 31.0781,
    y1: 17.7807,
    x2: 42.4908,
    y2: 17.7807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14_1334",
    x1: 31.0775,
    y1: 16.0016,
    x2: 42.491,
    y2: 16.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_1334",
    x1: 31.0778,
    y1: 14.0666,
    x2: 42.4909,
    y2: 14.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14_1334",
    x1: 5.52649,
    y1: 16.0017,
    x2: 17.1158,
    y2: 16.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14_1334",
    x1: 18.2405,
    y1: 16.0017,
    x2: 29.4964,
    y2: 16.0017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbOp);
export default __webpack_public_path__ + "static/media/JCB-op.d0c7699ad5a605c90bab0410c0a7244f.svg";
export { ForwardRef as ReactComponent };